import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BasicAuthInterceptor, ErrorInterceptor } from "./_helper";

import { ToastrModule } from "ngx-toastr";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { DataService } from "./_service/data.service";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { HyperLocalLeadComponent } from "./hyper-local-lead/hyper-local-lead.component";
import {
  HeaderComponent,
  HomeComponent,
  NotFoundComponent,
} from "./core/index";
import { DigitalDeskActivenessComponent } from "./digital-desk-activeness/digital-desk-activeness.component";
import { CallDistributionComponent } from "./call-distribution/call-distribution.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ExcelService } from "./_service/excel.service";
import { ModelReportComponent } from "./model-report/model-report.component";
import { LeadTypeComponent } from "./lead-type/lead-type.component";
import { SourceMediumComponent } from "./source-medium/source-medium.component";
import { ComparativeReportComponent } from "./comparative-report/comparative-report.component";
import { LqsLeadComponent } from "./lqs-lead-report/lqs-lead.component";
import { VNMappingComponent } from "./vn-mapping/vn-mapping.component";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HyperLocalLeadComponent,
    NotFoundComponent,
    HeaderComponent,
    DigitalDeskActivenessComponent,
    CallDistributionComponent,
    ModelReportComponent,
    LeadTypeComponent,
    SourceMediumComponent,
    ComparativeReportComponent,
    LqsLeadComponent,
    VNMappingComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    ToastrModule.forRoot({
      timeOut: 3000,
    }),
    NgxUiLoaderModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  providers: [
    CookieService,
    DataService,
    ExcelService,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
